export function $<T extends Element>(
    query: string,
    container: Element | Document = document,
): T | undefined {
    const element: Element | null = container.querySelector(query);

    if (element === null) {
        return;
    }

    return <T>element;
}
